import { FormattedMessage } from 'react-intl';
import { ExternalLinkSVG } from '../../../svgComponents/externalLinkSVG/ExternalLinkSVG';
import CollapsibleSection from '../../ui/CollapsibleSection/CollapsibleSection';
import messages from './FAQs.messages';
import styles from './FAQs.module.css';
import { tracking } from '@iwoca/frontend-tracking-library';

const FAQs = ({ questions }) => {
    return (
        <div className={styles.container} data-testid="faqs-section">
            {questions.map((item, index) =>
                !item ? null : (
                    <CollapsibleSection
                        className={styles.faq}
                        key={index}
                        title={item.title}
                        isCollapsible
                        isInitiallyOpen={false}
                        trackEvent={() =>
                            tracking.ampli.faqClicked({
                                faq_title: item.title
                            })
                        }
                    >
                        <div className={styles.contentWrapper}>
                            <div className={styles.description}>
                                {item.description}
                            </div>
                            {item.readMoreHref && (
                                <a
                                    className={styles.link}
                                    href={item.readMoreHref}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FormattedMessage {...messages.readMore} />{' '}
                                    <ExternalLinkSVG
                                        className={styles.externalLinkIcon}
                                    />
                                </a>
                            )}
                            <div className={styles.backgroundIcon}>
                                {item.backgroundIcon}
                            </div>
                        </div>
                    </CollapsibleSection>
                )
            )}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default FAQs;
